import { useState } from "react";

import { isNil } from "lodash";

import { useRoleContext } from "./useRoleContext";
import { useWriterComponentState } from "./useWriterComponentState";

interface CreateCustomerBillingPortalSessionResponse {
  url: string;
}

interface Props {
  onSessionCreatedSuccess: (url: string) => void;
}

export function useStripeCustomerBillingPortal(props: Props) {
  const { onSessionCreatedSuccess } = props;
  const [portalURL, setPortalURL] = useState<string | null>(null);
  const { company } = useRoleContext();
  const { loading, error, write } = useWriterComponentState({
    errorMessage:
      "Failed to create customer billing portal session. Please contact us if the issue persists.",
    writeConfig: {
      method: "post",
      url:
        company?.id != null
          ? `/stripe/companies/${company.id}/customer-portal-session`
          : "/",
    },
  });

  const requestCustomerBillingPortalSession = () => {
    if (isNil(company?.id)) {
      return;
    }
    write<CreateCustomerBillingPortalSessionResponse>(
      (response: CreateCustomerBillingPortalSessionResponse) => {
        setPortalURL(response.url);
        onSessionCreatedSuccess(response.url);
      },
    );
  };

  return {
    portalURL,
    loading,
    error,
    requestCustomerBillingPortalSession,
  };
}
